// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  width: 100%;
  height: 100%;
  padding: 20px;
}

.popup-image {
  width: 100%;
  height: auto;
  padding: 20px;
}

kendo-dialog#attachmentDialog.my-dialog div.k-window {
  min-width: 250px;
  width: 90%;
  max-height: 90%;
  height: auto;
}

kendo-dialog#attachmentDialog.my-dialog.pdf-mode div.k-window {
  height: 90%;
}

.pdf-mode .popup-image {
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/attachment-display/attachment-display.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,aAAA;AACJ;;AAEA;EACI,gBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":[".content {\n    width: 100%;\n    height: 100%;\n    padding: 20px;\n}\n\n.popup-image {\n    width: 100%;\n    height: auto;\n    padding: 20px;\n}\n\nkendo-dialog#attachmentDialog.my-dialog div.k-window {\n    min-width: 250px;\n    width: 90%;\n    max-height: 90%;\n    height: auto;\n}\n\nkendo-dialog#attachmentDialog.my-dialog.pdf-mode div.k-window {\n    height: 90%;\n}\n\n.pdf-mode .popup-image {\n    height: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
